/* eslint-disable */
// Bundled legal HTML per locale (edit this file when updating the cookie policy).
import type {AppLocale} from 'i18n/locales'

export const cookiesLegalBodyByLocale: Record<AppLocale, string> = {
  bg: `<p>Последна актуализация: 03.11.2025</p>

                <h3>1) Какво представляват бисквитките</h3>
                <p>
                  Бисквитките са малки текстови файлове, които се запазват на
                  Вашето устройство при посещение на уебсайтове. Те позволяват
                  функциониране на сайта, запомняне на предпочитания и анализ на
                  използването.
                </p>

                <h3>2) Кой поставя бисквитки</h3>
                <ul>
                  <li>
                    Първостранни бисквитки — поставяни от eventa.tv за основни
                    функционалности (сесия, сигурност, настройки).
                  </li>
                  <li>
                    Тристранни бисквитки — поставяни от наши
                    партньори/доставчици (Stripe, Google Analytics, Meta Pixel),
                    когато са активирани.
                  </li>
                </ul>

                <h3>3) Какви бисквитки използваме</h3>
                <ul>
                  <li>
                    Строго необходими:
                    <ul>
                      <li>
                        Необходими за функционирането на сайта, вход в профил,
                        плащания, сигурност.
                      </li>
                      <li>Тези бисквитки не изискват съгласие.</li>
                    </ul>
                  </li>
                  <li>
                    Функционални/предпочитания:
                    <ul>
                      <li>
                        Запомнят избори като език/настройки на интерфейса.
                      </li>
                      <li>Може да изискват съгласие според имплементацията.</li>
                    </ul>
                  </li>
                  <li>
                    Аналитични (Google Analytics):
                    <ul>
                      <li>
                        Помагат да разберем как се използва сайтът, за да го
                        подобряваме.
                      </li>
                      <li>
                        Активират се само при дадено съгласие чрез банера.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Рекламни/маркетингови (Meta Pixel):
                    <ul>
                      <li>
                        Измерване на ефективността на кампании и персонализиране
                        на реклами.
                      </li>
                      <li>
                        Активират се само при дадено съгласие чрез банера.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Платежни (Stripe):
                    <ul>
                      <li>
                        Осигуряват сигурна обработка на плащания и
                        предотвратяване на измами.
                      </li>
                      <li>
                        Обичайно се считат за необходими за извършване на
                        плащането.
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>4) Управление на съгласието</h3>
                <ul>
                  <li>
                    При първо посещение показваме банер за бисквитки. Можете да
                    приемете всички или да изберете категории.
                  </li>
                  <li>
                    Можете да промените избора си по всяко време чрез
                    настройките на браузъра или през „Настройки на бисквитките“
                    (ако е налично в сайта).
                  </li>
                  <li>
                    Можете да изтриете съществуващи бисквитки от настройките на
                    браузъра си.
                  </li>
                </ul>

                <h3>5) Срокове на съхранение</h3>
                <ul>
                  <li>
                    Сесийни бисквитки — изтичат при затваряне на браузъра.
                  </li>
                  <li>
                    Постоянни бисквитки — съхраняват се за определен период
                    (например дни/месеци) според доставчика.
                  </li>
                </ul>

                <h3>6) Трети страни и връзки към политики</h3>
                <ul>
                  <li>
                    Stripe — обработка на плащания и предотвратяване на измами
                    (вижте политиките на stripe.com).
                  </li>
                  <li>
                    Google Analytics — анализ на трафика (вижте политиките на
                    google.com/policies).
                  </li>
                  <li>
                    Meta (Facebook) — маркетинг/измерване (вижте политиките на
                    facebook.com/policy).
                  </li>
                </ul>
                <p>
                  Тези трети страни могат да използват собствени
                  бисквитки/пиксели. Нямаме контрол върху техните технологии.
                </p>

                <h3>7) Въздействие при отказ</h3>
                <p>
                  Ако откажете аналитични/рекламни бисквитки, сайтът ще продължи
                  да работи, но някои функционалности (персонализация, измерване
                  на кампании) може да са ограничени. Строго необходимите
                  бисквитки не могат да бъдат изключени в рамките на сайта.
                </p>

                <h3>8) „Do Not Track“</h3>
                <p>
                  В момента не отговаряме на сигнали „Do Not Track“ на
                  браузърите. Използвайте настройките на бисквитките за контрол
                  на предпочитанията.
                </p>

                <h3>9) Промени</h3>
                <p>
                  Можем да обновяваме тази Политика. Промените се публикуват на
                  тази страница и влизат в сила от публикуването.
                </p>

                <h3>10) Контакт</h3>
                <p>
                  За въпроси относно бисквитките: секцията „Контакт“ на
                  eventa.tv или по поща: АТОМИКА ГРУП ЕООД, България, гр. Велико
                  Търново, ул. „Никола Габровски“ 63-б.
                </p>
              </div>`,
  en: `<div >
                <p class="meta">Last updated: 3 November 2025</p>

                <h3>1) What cookies are</h3>
                <p>
                  Cookies are small text files stored on your device when you visit websites.
                  They enable the site to function, remember preferences and analyse usage.
                </p>

                <h3>2) Who sets cookies</h3>
                <ul>
                  <li>
                    First-party cookies — set by eventa.tv for core functionality (session,
                    security, settings).
                  </li>
                  <li>
                    Third-party cookies — set by our partners/providers (Stripe, Google Analytics,
                    Meta Pixel), when activated.
                  </li>
                </ul>

                <h3>3) What cookies we use</h3>
                <ul>
                  <li>
                    Strictly necessary:
                    <ul>
                      <li>
                        Required for the site to work, account login, payments, security.
                      </li>
                      <li>These cookies do not require consent.</li>
                    </ul>
                  </li>
                  <li>
                    Functional/preferences:
                    <ul>
                      <li>
                        Remember choices such as language/interface settings.
                      </li>
                      <li>May require consent depending on implementation.</li>
                    </ul>
                  </li>
                  <li>
                    Analytics (Google Analytics):
                    <ul>
                      <li>
                        Help us understand how the site is used so we can improve it.
                      </li>
                      <li>
                        Activated only when consent is given via the banner.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Advertising/marketing (Meta Pixel):
                    <ul>
                      <li>
                        Measure campaign effectiveness and personalise ads.
                      </li>
                      <li>
                        Activated only when consent is given via the banner.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Payment (Stripe):
                    <ul>
                      <li>
                        Enable secure payment processing and fraud prevention.
                      </li>
                      <li>
                        Usually considered necessary for completing the payment.
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>4) Managing consent</h3>
                <ul>
                  <li>
                    On first visit we show a cookie banner. You can accept all or choose categories.
                  </li>
                  <li>
                    You can change your choice at any time via browser settings or through „Cookie
                    settings” (if available on the site).
                  </li>
                  <li>
                    You can delete existing cookies from your browser settings.
                  </li>
                </ul>

                <h3>5) Storage periods</h3>
                <ul>
                  <li>
                    Session cookies — expire when you close the browser.
                  </li>
                  <li>
                    Persistent cookies — stored for a defined period (e.g. days/months) according to
                    the provider.
                  </li>
                </ul>

                <h3>6) Third parties and policy links</h3>
                <ul>
                  <li>
                    Stripe — payment processing and fraud prevention (see policies at stripe.com).
                  </li>
                  <li>
                    Google Analytics — traffic analysis (see policies at google.com/policies).
                  </li>
                  <li>
                    Meta (Facebook) — marketing/measurement (see policies at facebook.com/policy).
                  </li>
                </ul>
                <p>
                  These third parties may use their own cookies/pixels. We do not control their
                  technologies.
                </p>

                <h3>7) Effect of refusal</h3>
                <p>
                  If you refuse analytics/advertising cookies, the site will continue to work, but
                  some features (personalisation, campaign measurement) may be limited. Strictly
                  necessary cookies cannot be disabled within the site.
                </p>

                <h3>8) „Do Not Track“</h3>
                <p>
                  We do not currently respond to „Do Not Track” browser signals. Use cookie settings
                  to control preferences.
                </p>

                <h3>9) Changes</h3>
                <p>
                  We may update this Policy. Changes are published on this page and take effect from
                  publication.
                </p>

                <h3>10) Contact</h3>
                <p>
                  For questions about cookies: the „Contact” section on eventa.tv or by post: ATOMICA
                  GROUP Ltd, Bulgaria, Veliko Tarnovo, 63-b Nikola Gabrovski Street.
                </p>
              </div>`,
  de: `<div >
                <p class="meta">Letzte Aktualisierung: 3. November 2025</p>

                <h3>1) Was Cookies sind</h3>
                <p>
                  Cookies sind kleine Textdateien, die beim Besuch von Websites auf Ihrem Gerät
                  gespeichert werden. Sie ermöglichen den Betrieb der Website, speichern Präferenzen
                  und ermöglichen die Nutzungsanalyse.
                </p>

                <h3>2) Wer Cookies setzt</h3>
                <ul>
                  <li>
                    Erstanbieter-Cookies — von eventa.tv für Kernfunktionen (Sitzung, Sicherheit,
                    Einstellungen).
                  </li>
                  <li>
                    Drittanbieter-Cookies — von unseren Partnern/Anbietern (Stripe, Google Analytics,
                    Meta Pixel), wenn aktiviert.
                  </li>
                </ul>

                <h3>3) Welche Cookies wir verwenden</h3>
                <ul>
                  <li>
                    Unbedingt erforderlich:
                    <ul>
                      <li>
                        Notwendig für den Betrieb der Website, Anmeldung, Zahlungen, Sicherheit.
                      </li>
                      <li>Diese Cookies erfordern keine Einwilligung.</li>
                    </ul>
                  </li>
                  <li>
                    Funktional/Präferenzen:
                    <ul>
                      <li>
                        Merken sich Auswahlen wie Sprache/Oberflächeneinstellungen.
                      </li>
                      <li>Können je nach Implementierung eine Einwilligung erfordern.</li>
                    </ul>
                  </li>
                  <li>
                    Analytik (Google Analytics):
                    <ul>
                      <li>
                        Helfen uns zu verstehen, wie die Website genutzt wird, um sie zu verbessern.
                      </li>
                      <li>
                        Werden nur bei Einwilligung über das Banner aktiviert.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Werbung/Marketing (Meta Pixel):
                    <ul>
                      <li>
                        Messung der Kampagneneffektivität und Personalisierung von Anzeigen.
                      </li>
                      <li>
                        Wird nur bei Einwilligung über das Banner aktiviert.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Zahlung (Stripe):
                    <ul>
                      <li>
                        Gewährleisten sichere Zahlungsabwicklung und Betrugsprävention.
                      </li>
                      <li>
                        Gelten üblicherweise als für die Zahlung erforderlich.
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>4) Einwilligungsverwaltung</h3>
                <ul>
                  <li>
                    Beim ersten Besuch zeigen wir ein Cookie-Banner. Sie können alle akzeptieren oder
                    Kategorien wählen.
                  </li>
                  <li>
                    Sie können Ihre Auswahl jederzeit über die Browsereinstellungen oder über
                    „Cookie-Einstellungen“ (falls auf der Website verfügbar) ändern.
                  </li>
                  <li>
                    Sie können bestehende Cookies über die Einstellungen Ihres Browsers löschen.
                  </li>
                </ul>

                <h3>5) Speicherdauer</h3>
                <ul>
                  <li>
                    Sitzungs-Cookies — verfallen beim Schließen des Browsers.
                  </li>
                  <li>
                    Persistente Cookies — werden für einen festgelegten Zeitraum (z. B. Tage/Monate)
                    gemäß Anbieter gespeichert.
                  </li>
                </ul>

                <h3>6) Dritte und Links zu Richtlinien</h3>
                <ul>
                  <li>
                    Stripe — Zahlungsabwicklung und Betrugsprävention (siehe Richtlinien unter
                    stripe.com).
                  </li>
                  <li>
                    Google Analytics — Traffic-Analyse (siehe Richtlinien unter google.com/policies).
                  </li>
                  <li>
                    Meta (Facebook) — Marketing/Messung (siehe Richtlinien unter facebook.com/policy).
                  </li>
                </ul>
                <p>
                  Diese Dritten können eigene Cookies/Pixel verwenden. Wir haben keine Kontrolle über
                  deren Technologien.
                </p>

                <h3>7) Auswirkung bei Ablehnung</h3>
                <p>
                  Wenn Sie analytische/Werbe-Cookies ablehnen, funktioniert die Website weiterhin, aber
                  einige Funktionen (Personalisierung, Kampagnenmessung) können eingeschränkt sein. Unbedingt
                  erforderliche Cookies können innerhalb der Website nicht deaktiviert werden.
                </p>

                <h3>8) „Do Not Track“</h3>
                <p>
                  Derzeit reagieren wir nicht auf „Do Not Track“-Signale der Browser. Verwenden Sie die
                  Cookie-Einstellungen zur Steuerung Ihrer Präferenzen.
                </p>

                <h3>9) Änderungen</h3>
                <p>
                  Wir können diese Richtlinie aktualisieren. Änderungen werden auf dieser Seite veröffentlicht
                  und werden mit Veröffentlichung wirksam.
                </p>

                <h3>10) Kontakt</h3>
                <p>
                  Fragen zu Cookies: Bereich „Kontakt“ auf eventa.tv oder postalisch: ATOMICA GROUP Ltd,
                  Bulgarien, Weliko Tarnowo, Uliza „Nikola Gabrowski“ 63-b.
                </p>
              </div>`,
  tr: `<div >
                <p class="meta">Son güncelleme: 3 Kasım 2025</p>

                <h3>1) Çerezler nedir</h3>
                <p>
                  Çerezler, web sitelerini ziyaret ettiğinizde cihazınıza kaydedilen küçük metin dosyalarıdır.
                  Sitenin çalışmasını, tercihlerin hatırlanmasını ve kullanımın analiz edilmesini sağlarlar.
                </p>

                <h3>2) Çerezleri kim yerleştirir</h3>
                <ul>
                  <li>
                    Birinci taraf çerezleri — temel işlevler için eventa.tv tarafından (oturum, güvenlik,
                    ayarlar).
                  </li>
                  <li>
                    Üçüncü taraf çerezleri — ortaklarımız/sağlayıcılarımız tarafından (Stripe, Google Analytics,
                    Meta Pixel), etkinleştirildiğinde.
                  </li>
                </ul>

                <h3>3) Hangi çerezleri kullanıyoruz</h3>
                <ul>
                  <li>
                    Kesinlikle gerekli:
                    <ul>
                      <li>
                        Sitenin çalışması, hesaba giriş, ödemeler, güvenlik için gereklidir.
                      </li>
                      <li>Bu çerezler rıza gerektirmez.</li>
                    </ul>
                  </li>
                  <li>
                    İşlevsel/tercihler:
                    <ul>
                      <li>
                        Dil/arayüz ayarları gibi seçimleri hatırlar.
                      </li>
                      <li>Uygulamaya bağlı olarak rıza gerektirebilir.</li>
                    </ul>
                  </li>
                  <li>
                    Analitik (Google Analytics):
                    <ul>
                      <li>
                        Siteyi nasıl kullandığınızı anlamamıza yardımcı olur; iyileştirmek için kullanırız.
                      </li>
                      <li>
                        Yalnızca bildirim üzerinden verilen rızayla etkinleştirilir.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Reklam/pazarlama (Meta Pixel):
                    <ul>
                      <li>
                        Kampanya etkinliğini ölçer ve reklamları kişiselleştirir.
                      </li>
                      <li>
                        Yalnızca bildirim üzerinden verilen rızayla etkinleştirilir.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Ödeme (Stripe):
                    <ul>
                      <li>
                        Güvenli ödeme işlemi ve dolandırıcılığı önlemeyi sağlar.
                      </li>
                      <li>
                        Genellikle ödemenin tamamlanması için gerekli sayılır.
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>4) Rızanın yönetimi</h3>
                <ul>
                  <li>
                    İlk ziyarette çerez bildirimi gösteririz. Tümünü kabul edebilir veya kategoriler seçebilirsiniz.
                  </li>
                  <li>
                    Seçiminizi istediğiniz zaman tarayıcı ayarlarından veya sitede varsa „Çerez ayarları” üzerinden
                    değiştirebilirsiniz.
                  </li>
                  <li>
                    Mevcut çerezleri tarayıcı ayarlarınızdan silebilirsiniz.
                  </li>
                </ul>

                <h3>5) Saklama süreleri</h3>
                <ul>
                  <li>
                    Oturum çerezleri — tarayıcıyı kapattığınızda sona erer.
                  </li>
                  <li>
                    Kalıcı çerezler — sağlayıcıya göre belirli bir süre (ör. gün/ay) saklanır.
                  </li>
                </ul>

                <h3>6) Üçüncü taraflar ve politika bağlantıları</h3>
                <ul>
                  <li>
                    Stripe — ödeme işlemi ve dolandırıcılığı önleme (stripe.com politikalarına bakın).
                  </li>
                  <li>
                    Google Analytics — trafik analizi (google.com/policies politikalarına bakın).
                  </li>
                  <li>
                    Meta (Facebook) — pazarlama/ölçüm (facebook.com/policy politikalarına bakın).
                  </li>
                </ul>
                <p>
                  Bu üçüncü taraflar kendi çerezlerini/piksellerini kullanabilir. Teknolojileri üzerinde kontrolümüz
                  yoktur.
                </p>

                <h3>7) Reddin etkisi</h3>
                <p>
                  Analitik/reklam çerezlerini reddederseniz site çalışmaya devam eder; ancak bazı işlevler
                  (kişiselleştirme, kampanya ölçümü) kısıtlanabilir. Kesinlikle gerekli çerezler site içinde
                  kapatılamaz.
                </p>

                <h3>8) „Do Not Track“</h3>
                <p>
                  Şu anda tarayıcıların „Do Not Track” sinyallerine yanıt vermiyoruz. Tercihler için çerez
                  ayarlarını kullanın.
                </p>

                <h3>9) Değişiklikler</h3>
                <p>
                  Bu Politikayı güncelleyebiliriz. Değişiklikler bu sayfada yayınlanır ve yayım anında yürürlüğe
                  girer.
                </p>

                <h3>10) İletişim</h3>
                <p>
                  Çerezlerle ilgili sorular: eventa.tv „İletişim” bölümü veya posta ile: ATOMICA GROUP Ltd,
                  Bulgaristan, Veliko Tırnovo, Nikola Gabrovski Sokak 63-b.
                </p>
              </div>`,
  sv: `<div >
                <p class="meta">Senast uppdaterad: 3 november 2025</p>

                <h3>1) Vad cookies är</h3>
                <p>
                  Cookies är små textfiler som sparas på din enhet när du besöker webbplatser. De gör att
                  webbplatsen fungerar, att preferenser sparas och att användning kan analyseras.
                </p>

                <h3>2) Vem sätter cookies</h3>
                <ul>
                  <li>
                    First party-cookies — sätts av eventa.tv för kärnfunktioner (session, säkerhet,
                    inställningar).
                  </li>
                  <li>
                    Tredjepartscookies — sätts av våra partner/leverantörer (Stripe, Google Analytics, Meta
                    Pixel), när de aktiverats.
                  </li>
                </ul>

                <h3>3) Vilka cookies vi använder</h3>
                <ul>
                  <li>
                    Strikt nödvändiga:
                    <ul>
                      <li>
                        Nödvändiga för webbplatsens funktion, inloggning, betalningar, säkerhet.
                      </li>
                      <li>Dessa cookies kräver inte samtycke.</li>
                    </ul>
                  </li>
                  <li>
                    Funktionella/preferenser:
                    <ul>
                      <li>
                        Kommer ihåg val som språk/gränssnittsinställningar.
                      </li>
                      <li>Kan kräva samtycke beroende på implementering.</li>
                    </ul>
                  </li>
                  <li>
                    Analys (Google Analytics):
                    <ul>
                      <li>
                        Hjälper oss förstå hur webbplatsen används så att vi kan förbättra den.
                      </li>
                      <li>
                        Aktiveras endast när samtycke getts via bannern.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Reklam/marknadsföring (Meta Pixel):
                    <ul>
                      <li>
                        Mäter kampanjeffektivitet och personaliserar annonser.
                      </li>
                      <li>
                        Aktiveras endast när samtycke getts via bannern.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Betalning (Stripe):
                    <ul>
                      <li>
                        Möjliggör säker betalningshantering och bedrägeriförebyggande.
                      </li>
                      <li>
                        Anses vanligtvis nödvändiga för att genomföra betalningen.
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>4) Hantering av samtycke</h3>
                <ul>
                  <li>
                    Vid första besök visar vi en cookie-banner. Du kan acceptera alla eller välja kategorier.
                  </li>
                  <li>
                    Du kan när som helst ändra ditt val via webbläsarinställningar eller via „Cookieinställningar”
                    (om tillgängligt på webbplatsen).
                  </li>
                  <li>
                    Du kan ta bort befintliga cookies från webbläsarinställningarna.
                  </li>
                </ul>

                <h3>5) Lagringsperioder</h3>
                <ul>
                  <li>
                    Sessionscookies — upphör när du stänger webbläsaren.
                  </li>
                  <li>
                    Beständiga cookies — lagras under en bestämd period (t.ex. dagar/månader) enligt leverantör.
                  </li>
                </ul>

                <h3>6) Tredje part och policylänkar</h3>
                <ul>
                  <li>
                    Stripe — betalningshantering och bedrägeriförebyggande (se policys på stripe.com).
                  </li>
                  <li>
                    Google Analytics — trafikanalys (se policys på google.com/policies).
                  </li>
                  <li>
                    Meta (Facebook) — marknadsföring/mätning (se policys på facebook.com/policy).
                  </li>
                </ul>
                <p>
                  Dessa tredje parter kan använda egna cookies/pixlar. Vi har ingen kontroll över deras teknologier.
                </p>

                <h3>7) Effekt vid avvisande</h3>
                <p>
                  Om du avvisar analys-/annonscookies fungerar webbplatsen fortfarande, men vissa funktioner
                  (personalisering, kampanjmätning) kan vara begränsade. Strikt nödvändiga cookies kan inte stängas
                  av inom webbplatsen.
                </p>

                <h3>8) „Do Not Track“</h3>
                <p>
                  Vi svarar för närvarande inte på webbläsarnas „Do Not Track”-signaler. Använd cookieinställningar
                  för att styra preferenser.
                </p>

                <h3>9) Ändringar</h3>
                <p>
                  Vi kan uppdatera denna Policy. Ändringar publiceras på denna sida och träder i kraft vid
                  publicering.
                </p>

                <h3>10) Kontakt</h3>
                <p>
                  Frågor om cookies: avsnittet „Kontakt” på eventa.tv eller per post: ATOMICA GROUP Ltd, Bulgarien,
                  Veliko Tarnovo, Nikola Gabrovski-gatan 63-b.
                </p>
              </div>`,
}
